import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { FormControlLabel, Checkbox, Switch } from "../mui/core";
import { useLabeledText } from "./TextInputWithError";

export const StyledFormControlLabel = styled(
  ({ alignSelf, wasUpdated, ...props }) => <FormControlLabel {...props} />
)`
  margin-left: 0px;
  ${({ alignSelf }) => (alignSelf ? `align-self: ${alignSelf};` : "")}
  > .label {
    margin-left: 0px;
  }
  ${({ wasUpdated }) =>
    wasUpdated &&
    `
    & .MuiIconButton-label:before {
      position: absolute;
      content: "\\25CF";
      font-size: 10px;
      color: #ff9100;
      top: 0px;
      left: 0px;
      overflow: visible;
    }
  `}
`;

function isChecked(value, checkValues) {
  return checkValues.check === value;
}

function onChangeWrapper(event, checkValues, fn, handleChange) {
  const isChecked = event.target.checked;
  const checkValue = isChecked ? checkValues.check : checkValues.uncheck;
  const parsedEvent = {
    ...event,
    target: { name: event.target.name, value: checkValue },
  };
  fn(parsedEvent);
  handleChange && handleChange(parsedEvent);
}

const CheckboxWithError = ({
  label,
  value,
  checkValues = {
    check: true,
    uncheck: false,
  },
  onChange,
  handleChange,
  error,
  errorMessage,
  ignoreCaption,
  InputProps,
  isNotesFilter,
  useSwitch,
  formControlLabelProps,
  ignoreLabeledText,
  disabled,
  wasUpdated,
  ...checkboxProps
}) => {
  const Control = useSwitch ? Switch : Checkbox;

  const labeledText = useLabeledText(ignoreLabeledText) || disabled;

  return (
    <StyledFormControlLabel
      control={
        <Control
          {...checkboxProps}
          checked={isChecked(value, checkValues)}
          color="primary"
          onChange={event =>
            onChangeWrapper(event, checkValues, onChange, handleChange)
          }
          disabled={labeledText}
        />
      }
      label={label}
      isNotesFilter
      wasUpdated={wasUpdated}
      {...formControlLabelProps}
    />
  );
};

CheckboxWithError.defaultProps = {
  formControlLabelProps: {},
};

CheckboxWithError.propTypes = {
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  error: PropTypes.bool,
  ignoreLabeledText: PropTypes.bool,
};

export default CheckboxWithError;
